import React from 'react';
import './ArticleCard.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { motion } from 'framer-motion';
import { interactiveScale } from 'utilities/framerAnimations';

const colors = ['purple-dark', 'yellow', 'blue', 'purple'];

export default function ArticleCard({ article, index }) {
    return (
        <motion.a
            {...interactiveScale}
            href={article?.link}
            target="blank"
            //                                 modulo
            styleName={`article-card ${colors[index % 4]}`}
        >
            <div styleName="left">
                <h4>{article?.title}</h4>
                <p>{article?.subText}</p>
            </div>
            <div styleName="circle">
                <FontAwesomeIcon icon={faArrowRight} />
            </div>
        </motion.a>
    );
}
